var RefinementContextLogger, RefinementContextLoggerDesktop,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

RefinementContextLogger = require('./rcl');

RefinementContextLoggerDesktop = (function(superClass) {
  var dealsSearch, paginatedDealsBuilder, sortsApp;

  extend(RefinementContextLoggerDesktop, superClass);

  function RefinementContextLoggerDesktop() {
    return RefinementContextLoggerDesktop.__super__.constructor.apply(this, arguments);
  }

  sortsApp = void 0;

  dealsSearch = void 0;

  paginatedDealsBuilder = void 0;

  RefinementContextLoggerDesktop.prototype.events = {
    'click .card-ui a': '_addLoggerEvent'
  };

  RefinementContextLoggerDesktop.prototype.initialize = function(arg) {
    this.refinementUIAppInstance = arg.refinementUIAppInstance;
  };

  RefinementContextLoggerDesktop.prototype.setSortsApp = function(sorts) {
    return sortsApp != null ? sortsApp : sortsApp = sorts;
  };

  RefinementContextLoggerDesktop.prototype.setDealsSearch = function(search) {
    return dealsSearch = search;
  };

  RefinementContextLoggerDesktop.prototype.setPaginatedDealsBuilder = function(paginatedBuilder) {
    return paginatedDealsBuilder = paginatedBuilder;
  };

  RefinementContextLoggerDesktop.prototype._getEventMeta = function(event) {
    var eventDetails;
    eventDetails = RefinementContextLoggerDesktop.__super__._getEventMeta.call(this, event);
    eventDetails.pagination.offset = this._getOffset();
    eventDetails.pagination.count = this._getDealsCount();
    return eventDetails;
  };

  RefinementContextLoggerDesktop.prototype._getSort = function() {
    if ((sortsApp != null ? sortsApp.sortToggleView : void 0) != null) {
      return sortsApp.sortToggleView.$el.val();
    }
    return this.$el.find('#grpn-sorts-select').val();
  };

  RefinementContextLoggerDesktop.prototype._getCategoryHierarchy = function() {
    var categoryLogEntry, currentCategory, currentDepth, ref, ref1, selectedRefinements;
    selectedRefinements = (ref = this.refinementUIAppInstance) != null ? ref.selectedRefinements : void 0;
    currentCategory = selectedRefinements != null ? selectedRefinements.category.selectedValues[0] : void 0;
    categoryLogEntry = RefinementContextLoggerDesktop.__super__._getCategoryHierarchy.call(this);
    while (currentCategory != null) {
      categoryLogEntry.id = currentCategory.name;
      currentDepth = ++categoryLogEntry.level;
      categoryLogEntry["category" + currentDepth] = currentCategory.name;
      currentCategory = (ref1 = currentCategory.selectedValues) != null ? ref1[0] : void 0;
    }
    return categoryLogEntry;
  };

  RefinementContextLoggerDesktop.prototype._getCurrentPageNumber = function() {
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getPageNumber();
    }
    if (dealsSearch != null) {
      return dealsSearch.getPageNumber();
    }
    return parseInt(this.$el.find('.pagination_links li.box').text(), 10);
  };

  RefinementContextLoggerDesktop.prototype._getOffset = function() {
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getStartingIndex();
    }
    if (dealsSearch != null) {
      return dealsSearch.getStartingIndex();
    }
    return parseInt(this.$el.find('.pagination .results').text(), 10);
  };

  RefinementContextLoggerDesktop.prototype._getDealsCount = function() {
    var range;
    if (paginatedDealsBuilder != null) {
      return paginatedDealsBuilder.search.getDealsCount();
    }
    if (dealsSearch != null) {
      return dealsSearch.getDealsCount();
    }
    range = this.$el.find('.pagination .results').text().split(' of')[0].trim().split(' - ');
    return range[1] - range[0] + 1;
  };

  RefinementContextLoggerDesktop.prototype._getRefinements = function() {
    var friendlyNameShort, i, len, name, ref, ref1, refinementKey, refinementList, selectedRefinements, selectedValues;
    refinementList = RefinementContextLoggerDesktop.__super__._getRefinements.call(this);
    selectedRefinements = (ref = this.refinementUIAppInstance) != null ? ref.selectedRefinements : void 0;
    for (refinementKey in selectedRefinements) {
      selectedValues = selectedRefinements[refinementKey].selectedValues;
      if (refinementKey !== 'category') {
        for (i = 0, len = selectedValues.length; i < len; i++) {
          ref1 = selectedValues[i], name = ref1.name, friendlyNameShort = ref1.friendlyNameShort;
          refinementList.push({
            filter: refinementKey,
            uuid: name,
            value: friendlyNameShort
          });
        }
      }
    }
    return refinementList;
  };

  return RefinementContextLoggerDesktop;

})(RefinementContextLogger);

module.exports = RefinementContextLoggerDesktop;

//# sourceMappingURL=data:application/json;base64,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
